<template>
  <div class="outer-container">
    <div class="inner-container">
      <img
        style="
          margin-bottom: 50px;
          margin-left: 50px;
          margin-right: 50px;
          width: 120px;
          height: 120px;
        "
        v-if="
          deluge?.canvaspro_core_info?.product_name.toUpperCase() === 'OMNI'
        "
        :src="omniSvg" />
      <img
        style="
          margin-bottom: 50px;
          margin-left: 50px;
          margin-right: 50px;
          width: 120px;
          height: 120px;
        "
        v-if="deluge?.canvaspro_core_info?.product_name.toUpperCase() === 'ONE'"
        :src="oneSvg" />

      HELLO DAVE
      <div
        style="
          color: white;
          font-size: 24px;
          font-weight: bolder;
          margin-bottom: 40px;
        "
        class="CanvasProFont">
        End User License Agreement
      </div>
      <div
        style="
          color: white;
          height: 500px;
          width: 600px;
          overflow: auto;
          white-space: pre-wrap;
        ">
        {{ eula }}
      </div>

      <div
        style="display: flex; justify-content: space-between; width: 600px"
        class="mt-4">
        <v-spacer />
        <v-btn
          color="primary"
          style="width: 200px"
          @click="emit('close')"
          :loading="loading"
          prepend-icon="mdi-check-circle">
          Accept
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script setup>
import omniSvg from '../../../assets/OmniLight.svg';
import oneSvg from '../../../assets/OneLight.svg';
import { deluge } from '@/stores/deluge.js';
import { ref } from 'vue';
const emit = defineEmits(['close']);

const loading = ref(false);
</script>

<style scoped>
.outer-container {
  height: 100vh;
  width: 100vw;
  background: #1a1a1f;
  position: absolute;
  z-index: 99999999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  opacity: 1;
}

.inner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 600px;
}
</style>
